import React from 'react';

const CardItemContainer = ({ children, className }) => {
  return (
    <div className={`card-item-container d-flex ${className}`}>
      {children}
    </div>
  );
}

export { CardItemContainer };
